import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SIDEKICK_TRANSLATION_NAMESPACE } from '../../translations';
import useStyles from './ShareViaEmailDialog.styles';

/**
 * The `bd-ui` large button's minimum width and height, so the footer
 * holds its shape when the real buttons come back.
 */
const SKELETON_BUTTON_WIDTH_PX = 108;
const SKELETON_BUTTON_HEIGHT_PX = 48;
const SKELETON_BUTTON_KEYS = ['cancel', 'send'] as const;

/**
 * Stand-in for the dialog's Cancel and Send buttons while a share is
 * in flight. The skeletons are decorative; the wrapper carries the
 * "sending" status for assistive tech.
 */
function ShareActionsSkeleton() {
  const { classes } = useStyles();
  const { t } = useTranslation(SIDEKICK_TRANSLATION_NAMESPACE);

  return (
    <div
      className={classes.actionsSkeleton}
      role="status"
      aria-label={t('chat.share.dialog.sendingAriaLabel')}
      data-testid="ai-sidekick-share-actions-skeleton"
    >
      {SKELETON_BUTTON_KEYS.map((key) => (
        <Skeleton
          key={key}
          variant="rounded"
          animation="pulse"
          width={SKELETON_BUTTON_WIDTH_PX}
          height={SKELETON_BUTTON_HEIGHT_PX}
          className={classes.actionSkeleton}
          aria-hidden
          data-testid={`ai-sidekick-share-${key}-skeleton`}
        />
      ))}
    </div>
  );
}

export default ShareActionsSkeleton;
